import BaseEdit from './BaseEdit';

export default BaseEdit;
